<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-note"></i>
                    <span>{{$t('dashboard.notes.title')}}</span>
                </h2>
                <div @click.prevent="addNew" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-plus"></i>
                    <a class="button--link hidden-xs">{{$t('dashboard.notes.add_new')}}</a>
                </div>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="loading">
                    <div class="spinner"></div>
                </div>
                <div v-else-if="!noteItems.length" class="panel--empty">
                    <center>{{$t('dashboard.notes.no_notes')}}</center>
                </div>
                <div v-else class="notes">
                    <notes-item v-for="item in noteItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.notes.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.notes.see_all')}}</div>
            </div>
        </div>
        <note-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import NotesItem from './NotesItem';
    import NoteModal from '@/components/modals/dashboard/NoteModal';

    import { GET_NOTES } from '@/store/modules/notes';

    import Note from '@/models/Note';

    @Component({
        components: {
            NotesItem,
            NoteModal,
        }
    })
    export default class NotesPanel extends Vue {
        name = 'notes-panel';
        expanded = false;

        created() {
            this.$store.dispatch(GET_NOTES, {});
        }

        get loading() {
            return this.$store.state.notes.loading;
        }

        get noteItems() {
            return this.$store.state.notes.notes;
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.noteItems.length && this.noteItems.length > 2;
        }

        addNew() {
            const url = `/trajectories/${this.$store.state.trajectory.trajectory.id}/notes`;
            const note = new (Note.makeModel(url));
            this.$modal.show('note-modal', { note });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/NotesPanel.vue